__turbopack_context__.v({
  "divider": "ResultsList-module-scss-module__9o3qva__divider",
  "label": "ResultsList-module-scss-module__9o3qva__label",
  "root": "ResultsList-module-scss-module__9o3qva__root",
});
